import { render, staticRenderFns } from "./agentDistributionGoods.vue?vue&type=template&id=4d4b994e&scoped=true&"
import script from "./agentDistributionGoods.vue?vue&type=script&lang=js&"
export * from "./agentDistributionGoods.vue?vue&type=script&lang=js&"
import style0 from "./agentDistributionGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./agentDistributionGoods.vue?vue&type=style&index=1&id=4d4b994e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b994e",
  null
  
)

component.options.__file = "agentDistributionGoods.vue"
export default component.exports